/** Business-dialect overrides. Sparse: a missing key falls back to en. */
export const account = {
    practiceNameFallback: 'Your business',
    organisationLabel: 'Business',
    profile: {
        heading: 'Business Profile',
        logoAlt: 'Business logo',
        nameLabel: 'Business trading name',
        nameSaveError: 'Failed to update business name. Please try again.',
        removeLogoMessage: "Remove your business logo? It won't appear on invoices anymore.",
    },
    subscription: {
        contactOwnerToUpgrade: 'Contact the business owner to upgrade',
    },
    dataExport: {
        description: 'Download a copy of all your business data in JSON format',
        csvDescription: 'Download or upload your business data as CSV files',
    },
    xero: {
        askOwnerToConnect: 'Ask your business owner to connect a Xero account',
        askOwnerToReconnect: 'Ask your business owner to reconnect Xero',
    },
    references: {
        heading: 'Project References',
        prefixHint: 'Prepended to each project number. e.g. PROJ- → PROJ-0001.',
        nextReference: 'Next project reference:',
        saveErrorTitle: 'Failed to save project reference settings',
    },
    team: {
        memberRoleDescription: 'Standard access to projects, invoices, and clients.',
        memberRoleManageDetail: 'Manage clients and projects',
        bookkeeperRoleNoInboxDetail: 'Cannot read business email or team inboxes',
        leavePracticeTitle: 'Leave business',
        leavePracticeMessage: "Leave this business? You'll lose access to all business data.",
        removeMemberFromPracticeMessage: 'Remove {{name}} from this business?',
    },
    rates: {
        emailBillingTimeBasedOption: 'Time-based (project or client rate)',
        emailBillingFixedRateHint: 'Every email bills the same flat fee, regardless of the project, client, or member rate.',
        emailBillingTimeBasedHint: 'Emails bill as the time below, charged at the project, client, or member hourly rate (whichever applies first).',
    },
    deletion: {
        accountDataWarning: 'All data will be permanently deleted - clients, projects, activities, invoices, and all team member access. Your Bill subscription will also be cancelled.',
    },
    ledgerSettings: {
        vatNumberLabel: 'Business VAT number:',
        defaultRecoverableAccountLabel: 'Default expense account',
        defaultRecoverableAccountSaved: 'Default expense account saved',
    },
};
